





















































import { computed, defineComponent, reactive } from "@vue/composition-api";
import { Icon2 } from "@micad/vue-components";
import Vue from "vue";

// function readImage(file: File) {
//   // Check if the file is an image.
//   if (file.type && !file.type.startsWith("image/")) {
//     console.log("File is not an image.", file.type, file);
//     return;
//   }
// }

export default defineComponent({
  name: "ImageUploadWidget",
  components: { Icon2 },
  props: { url: { type: String, default: "" }, title: { type: String } },
  setup(p, c) {
    const state = reactive({
      filesChange: filesInputChange,
      imageId: computed(() => p.title || ""),
      fileFormId: computed(() => "files_" + p.title || ""),
      drag: (e: Event) => (state.dragOver = e.type !== "dragleave"),
      dragOver: false,
      imageDrop(e: DragEvent) {
        state.dragOver = false;
        const fileList = e.dataTransfer?.files;
        readFiles(fileList);
      },
    });
    function filesInputChange(evt: Event) {
      const tgt = evt.target as HTMLInputElement;
      const files = tgt.files;
      readFiles(files);
    }

    function readFiles(files?: FileList | null) {
      if (FileReader && files && files.length) {
        const fr = new FileReader();
        fr.onload = function () {
          c.emit("update:url", String(fr.result));
        };
        fr.readAsDataURL(files[0]);
      }
      // Not supported
      else {
        Vue.$toast.error("Image file cannot be read");
      }
    }
    return state;
  },
});
